import style from './ListContexts.module.scss'
import React from "react";
import Pagination from "../IU/Pagination/Pagination";
import ListOptions from "../ListOptions";

const ListContexts = ({ setCurrentContext, tripContexts, page, setPage}: any) => {


    return (
        <div className={style['container']}>

            <table className={style['container-table']} cellSpacing="0">
                <thead>
                <tr className={style['container-table-header']}>
                    <th className={style['container-table-options']}>#</th>
                    <th className={style['container-table-header-visibility']}>Nom</th>
                    <th className={style['container-table-header-city']}>Icone</th>
                    <th className={style['container-table-options']}></th>
                </tr>
                </thead>
                <tbody>
                {tripContexts?.map((context) => (
                    <tr key={context?.id}>
                        <td className={style['container-table-header-id']} data-label="id">{context?.id}</td>
                        <td className={style['container-table-header-city']} data-label="name">{context?.name}</td>
                        <td className={style['container-table-header-country']} data-label="icone"><img
                            src={context?.media?.url} className={style['icon']} alt={"icone"}/></td>
                        <td className={style['container-table-options']}>
                            <ListOptions data={context} page={page} setData={setCurrentContext}/>
                        </td>
                    </tr>
                ))}
                </tbody>
                <tfoot>
                <tr>
                    <td colSpan={4}>
                        <Pagination
                            page={page}
                            setPage={setPage}
                            isEmpty={!tripContexts || tripContexts === 0}
                            totalOfItems={tripContexts?.length}
                        />
                    </td>
                </tr>
                </tfoot>
            </table>
        </div>
    )

}

export default ListContexts